import React, {ReactElement, SVGProps} from 'react';
import Tooltip from '@material-ui/core/Tooltip';

interface HighlightIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
export const HighlightIcon: React.FC<HighlightIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={props.className + ' icon highlight'}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512">
        <path d="M219.7 459.7C208.1 470.4 193.7 473.8 180.1 469.8L147.3 502.6C141.3 508.6 133.2 512 124.7 512H40C22.33 512 8 497.7 8 480V475.3C8 466.8 11.37 458.7 17.37 452.7L90.18 379.9C86.21 366.3 89.58 351 100.3 340.3L143.1 296.6V248.6C143.1 233.2 151.4 218.7 164 209.6L441.8 10.2C451 3.567 462.1 0 473.5 0C487.9 0 501.7 5.726 511.9 15.92L544.1 48.08C554.3 58.27 559.1 72.1 559.1 86.51C559.1 97.88 556.4 108.1 549.8 118.2L350.4 395.1C341.3 408.6 326.8 416 311.4 416H263.4L219.7 459.7zM191.1 316.5L139.9 368.6L191.4 420.1L243.5 368H311.4L327.5 345.5L214.5 232.5L191.1 248.6L191.1 316.5zM511.1 86.51C511.1 84.83 511.3 83.21 510.1 82.02L477.1 49.86C476.8 48.67 475.2 48 473.5 48C472.2 48 470.9 48.42 469.8 49.19L254 204.1L355.9 305.1L510.8 90.21C511.6 89.13 511.1 87.84 511.1 86.51L511.1 86.51zM142.7 439.3L120.7 417.3L73.94 464H118.1L142.7 439.3z" />
      </svg>
    </Tooltip>
  );
};
